import { render, staticRenderFns } from "./ShoppingByCategory.vue?vue&type=template&id=1480ddd2&scoped=true&"
import script from "./ShoppingByCategory.vue?vue&type=script&lang=js&"
export * from "./ShoppingByCategory.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingByCategory.vue?vue&type=style&index=0&id=1480ddd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1480ddd2",
  null
  
)

export default component.exports